import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

function Services() {
  const services = [
  {
  id: "01",
  title: "Web Development",
  desc: "Responsive and scalable web applications using React.js, Vue.js, Angular, and Node.js.",
  icon: "assets/img/icons/service-icon1.svg",
  link: "/web-development", // 🔗 redirection link
},
{
  id: "02",
  title: "Mobile App Development",
  desc: "Native and cross-platform mobile apps for iOS & Android using Flutter and React Native.",
  icon: "assets/img/icons/service-icon2.svg",
  link: "/mobile-app-development", // 🔗 redirection link}
  },
  {
    id: "03",
    title: "Internet of Things (IoT)",
    desc: "End-to-end IoT architecture: devices, connectivity, cloud integration Data collection, monitoring dashboards",
    icon: "assets/img/icons/service-icon3.svg",
    link: "/internet-of-things",
  },
  {
    id: "04",
    title: "UI/UX & Digital Design",
    desc: "User research, prototyping, design systems, accessibility-focused design",
    icon: "assets/img/icons/service-icon4.svg",
    link: "/ui-ux-design",
  },
  {
    id: "05",
    title: "Digital Marketing",
    desc: "SEO(Search Engine Optimization) SEM(Search Engine Marketing) Social Media Integration Email Marketing",
    icon: "assets/img/icons/service-icon5.svg",
    link: "/digital-marketing",
  },
  {
    id: "06",
    title: "Cloud Solutions",
    desc: "Cloud migration, serverless architecture, and scalable infrastructure on AWS, Azure, and Google Cloud.",
    icon: "assets/img/icons/service-icon6.svg",
    link: "/cloud-solutions",
  }
];

  return (
    <>
        {/* HERO AREA STARTS */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Our Services</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> <span>Our Services</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* HERO AREA ENDS */}

      {/* SERVICE AREA STARTS */}
      <div className="service1-section-area sp2">
        <div className="container">
         <div className="space32"></div>
    <div className="row">
      {services.map((service, index) => (
        <div
          className="col-lg-4 col-md-6"
          key={service.id}
          data-aos="zoom-in"
          data-aos-duration={800 + index * 100}
        >
          <a href={service.link}>
          <div className="service1-boxarea">
            <div className="icons">
              <img src={service.icon} alt={service.title} />
            </div>
            <div className="arrow">
              <a href={service.link}>
                <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </div>
            <div className="space24"></div>
            <a href={service.link}>{service.title}</a>
            <div className="space16"></div>
            <p>{service.desc}</p>
            <div className="space24"></div>
            <h5>{service.id}</h5>
          </div>
          </a>
        </div>
      ))}
    </div>
        </div>
      </div>
      {/* SERVICE AREA ENDS */}

      {/* ABOUT AREA STARTS */}
      <div 
        className="about6-section-area-widget sp1" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/service-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="about6-header heading2 bg-heading">
                <h5>
                  <span>
                    <img src="assets/img/icons/sub-logo1.svg" alt="" />
                  </span>
                  our mission/vision
                </h5>
                <div className="space18"></div>
                <h2 className="text-anime-style-3">
                  Driving Innovation: Our Mission Vision at Eitech
                </h2>
                <div className="space16"></div>
                <p data-aos="fade-left" data-aos-duration="900">
                  At the of innovation, our cutting-edge IT solutions are designed transform your business ETech operations.
                </p>
                <div className="space24"></div>
                <div className="about-boxarea" data-aos="fade-left" data-aos-duration="1000">
                  <div className="icons">
                    <img src="assets/img/icons/service-icon2.svg" alt="" />
                  </div>
                  <br/>
                  <div className="content-area">
                    <a href="service-single.html">Network Infrastructure Solutions</a>
                    <div className="space16"></div>
                    <p>In today's fast-paced world, technology is the backbone of success. Our comprehensive IT.</p>
                  </div>
                </div>
                <div className="space24"></div>
                <div className="about-boxarea" data-aos="fade-left" data-aos-duration="1100">
                  <div className="icons">
                    <img src="assets/img/icons/service-icon5.svg" alt="" />
                  </div>
                  <br/>
                  <div className="content-area">
                    <a href="service-single.html">Performance Tailored IT Services</a>
                    <div className="space16"></div>
                    <p>Our tailored IT services are crafted to meet your unique business needs, ensuring that.</p>
                  </div>
                </div>
                <div className="space32"></div>
                <div className="btn-area1" data-aos="fade-left" data-aos-duration="1200">
                  <a href="/contact" className="vl-btn2">
                    See How We Can Help<i className="fa-solid fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-6">
              <div className="images-area">
                <img src="assets/img/elements/elements27.png" alt="" className="elements27" />
                <div className="img1 image-anime reveal">
                  <img src="assets/img/all-images/about/about-img13.png" alt="" />
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime reveal">
                      <div className="space30"></div>
                      <img src="assets/img/all-images/about/about-img14.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime reveal">
                      <div className="space30"></div>
                      <img src="assets/img/all-images/about/about-img15.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ABOUT AREA ENDS */}
    </>
  )
}
export default Services;
